import { getUserKey } from "utils/getUserKey";

export interface RecentlyVisitedApp {
    appId: string;
    name: string;
    lastVisit: string;
    orgId: string;
    orgName?: string;
    smallIcon?: string;
}

interface AppToLocalStorageArgs {
    appId: string;
    name: string;
    orgId: string;
    orgName?: string;
    smallIcon?: string;
}

export function getRecentlyVisitedApps(): RecentlyVisitedApp[] {
    // eject if there is no localStorage
    if (!localStorage) {
        return [];
    }

    const storageKey = `user-${getUserKey()}-recent-apps`;
    const storedApps: RecentlyVisitedApp[] = localStorage.hasOwnProperty(storageKey)
        ? JSON.parse(localStorage[storageKey])
        : [];

    return storedApps;
}

export function setRecentlyVisitedApps(args: AppToLocalStorageArgs): void {
    // eject if there is no localStorage
    if (!localStorage) {
        return;
    }

    const storedApps = getRecentlyVisitedApps();
    const storageKey = `user-${getUserKey()}-recent-apps`;
    const recentlyVisitedApp: RecentlyVisitedApp = {
        appId: args.appId,
        lastVisit: Date.now().toString(),
        name: args.name,
        orgId: args.orgId,
        orgName: args.orgName,
        smallIcon: args.smallIcon
    };

    let mutableApps: RecentlyVisitedApp[] = storedApps.filter((storedApp: RecentlyVisitedApp) => {
        return storedApp.appId !== args.appId;
    });

    mutableApps = [].concat(recentlyVisitedApp, mutableApps).slice(0, 10);
    localStorage.setItem(storageKey, JSON.stringify(mutableApps));
}
